import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FECC00",
  stroke: "#EBEBEB",
  d: "M22.867.5H3.133A2.63 2.63 0 0 0 .5 3.129v11.706a2.63 2.63 0 0 0 2.633 2.629h19.734a2.631 2.631 0 0 0 2.633-2.629V3.13A2.631 2.631 0 0 0 22.867.5Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FECC00",
  d: "M25 6.348v5.285H1V6.348z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D50029",
  d: "M8.738 8.556c-.105.142-.28.388-.387.532-.054.073-.152.206.172.206h1.71l.506-.687c.314-.425.027-1.31-1.096-1.31H5.221l-.767 1.04h4.18c.21 0 .207.08.104.219m-1.255.994c-.325 0-.227-.133-.173-.206l.39-.53c.103-.139.106-.219-.105-.219H5.684l-1.54 2.088h3.755c1.24 0 1.931-.842 2.144-1.133zm2.443 1.133h2.203l.835-1.133H10.76zm5.684-3.386-.845 1.145h-.983l.844-1.145h-2.202L10.95 9.294h5.389l1.473-1.997zm-2.498 3.386h2.202l.836-1.133h-2.202zM1 9.997v.24h3.068l.177-.24zm3.575-.447H1v.24h3.398zM1 10.683h2.74l.176-.239H1zm20.767-.445H25v-.24h-3.056zm-.329.445H25v-.239h-3.385zm.836-1.133-.178.24H25v-.24zm-2.885-.256 1.473-1.997H18.53l-1.475 1.997zm-2.523.256s-.16.22-.239.326c-.276.372-.032.807.87.807h3.538l.835-1.133z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }